export default __webpack_public_path__ + "static/media/design-analytics2.f67d8db1.png";